<div *transloco="let t" class="flex items-center justify-between h-12 px-1">
  <span class="font-medium ml-3">{{ title() }}</span>
  <button
    appearance="flat"
    iconStart="@tui.chevron-up"
    size="s"
    tuiHintDirection="start"
    tuiIconButton
    type="button"
    [tuiHint]="t('Masquer')"
    (click)="syncCenterState.close()"></button>
</div>

@if (globalProgress().total > 0) {
  <progress
    class="w-full"
    size="xs"
    tuiProgressBar
    [max]="globalProgress().total"
    [value]="globalProgress().done"></progress>
}

<div *transloco="let t" class="flex flex-col">
  @for (item of items(); track item.key) {
    <pxc-sync-center-item
      [item]="item"
      (deleteChild)="deleteChild.emit($event)"
      (resumeChild)="resumeChild.emit($event)"
      (retryChild)="retryChild.emit($event)" />
  } @empty {
    <pxc-empty-state
      class="border-t border-border-secondary"
      icon="@tui.check-circle"
      [title]="t('Toutes vos vidéos sont synchronisées')" />
  }
</div>
